// Named entities we explicitly want to decode. Anything not listed here
// (e.g. &copy;, &trade;, &hellip;) is left encoded so we don't surprise users
// who typed a literal entity reference. Numeric/hex refs (&#NN;, &#xNN;) are
// handled generically by the regex below — those always represent the literal
// character the backend escaped, so it's safe to decode all of them.
const NAMED_ENTITIES = {
  apos: '\'',
  quot: '"',
  lt: '<',
  gt: '>',
  amp: '&',
  // U+00A0 (true non-breaking space) preserves wrapping/copy-paste fidelity,
  // unlike a plain ASCII space.
  nbsp: '\u00A0',
};

// Single pass: decimal ref, hex ref (case-insensitive), or a named ref. The
// regex doesn't re-scan replacements, so already-double-escaped sequences like
// `&amp;lt;` decode to `&lt;` and stop instead of cascading to `<`.
const ENTITY_REGEX = /&(?:#([0-9]+)|#x([0-9a-fA-F]+)|([a-zA-Z][a-zA-Z0-9]+));/g;

const decodeHtmlEntities = (str) => {
  if (!str) return str;
  return str.replace(ENTITY_REGEX, (match, dec, hex, named) => {
    if (dec !== undefined) {
      const code = parseInt(dec, 10);
      return Number.isFinite(code) ? String.fromCodePoint(code) : match;
    }
    if (hex !== undefined) {
      const code = parseInt(hex, 16);
      return Number.isFinite(code) ? String.fromCodePoint(code) : match;
    }
    return Object.prototype.hasOwnProperty.call(NAMED_ENTITIES, named)
      ? NAMED_ENTITIES[named]
      : match;
  });
};

// Stored video URLs can carry stacked escaping (&amp;amp;…); decode repeatedly
// until stable, capped at 10 passes in case of pathological input.
export const decodeVideoUrl = (url) => {
  let decoded = url || '';
  for (let i = 0; i < 10; i += 1) {
    const next = decodeHtmlEntities(decoded);
    if (next === decoded) break;
    decoded = next;
  }
  return decoded;
};

export default decodeHtmlEntities;
